<template>
  <v-dialog persistent class="elevation-2" width="280px" v-model="dialogActive">
    <v-card style="border-radius: 5px;">
      <v-card-text class="ma-0 pa-1">
        <v-layout row justify-center align-center>
          <v-text-field
            box
            v-if="dialogActive"
            ref="bookmarkTitleTextField"
            @keyup.enter="save"
            color="grey"
            single-line
            autofocus
            maxlength="50"
            full-width
            hide-details
            label
            v-model="newBookmarkTitle"
            placeholder="Gi bokmerket et navn"
          ></v-text-field>
        </v-layout>
        <v-layout row justify-end align-end>
          <v-btn @click="cancel" block depressed>Avbryt</v-btn>
          <v-btn color="blue" block dark height="50px" depressed @click="save"
            >Ok</v-btn
          >
        </v-layout>
      </v-card-text>

      <v-divider></v-divider>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MapBookmarksAddDialog",
  data: () => {
    return {
      newBookmarkTitle: ""
    };
  },
  watch: {
    dialogActive(newVal) {
      if (newVal) {
        this.newBookmarkTitle = this.bookmarkTitle;
      }
    }
  },
  methods: {
    cancel: function() {
      this.$emit("cancel");
    },
    save: function() {
      this.$emit("save", this.newBookmarkTitle);
    }
  },
  props: {
    dialogActive: Boolean,
    bookmarkTitle: String
  }
};
</script>

<style></style>
